module.exports = __webpack_public_path__ + "img/social-info-bg-2.9e769522.svg";